/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="11.76"
        height="19.03"
        viewBox="0 0 11.76 19.03"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M4.31 18.99v-19h-.53C.78.16.19 2.99.05 5.75a8.43 8.43 0 0 0 1.3 5.53v7.66Zm4.5-19 2.5.1v.43s.18 1.72.31 3.52v.45l.06.89c.11 2.12-1 2.9-1.54 3.16v10.43h-3V8.59a3.25 3.25 0 0 1-1.73-3.23A47.83 47.83 0 0 1 5.94.45L6 .03Zm0 1h-.3v4.25h-1V.99H7c-.22 1.45-.37 2.9-.45 4.36-.05 1.82 1 2.28 1.37 2.38l.36.1v10.15h1V7.81l.42-.07s1.22-.25 1.12-2.27c-.09-1.62-.26-3.51-.35-4.37h-.48v4.2h-1V1.05Zm-5.47.07v16.89h-1v-7l-.13-.14s-1.35-1.59-1.17-5c.15-2.99.82-4.38 2.27-4.71Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'KnifeAndForkIcon';

export default Icon;
